import React from "react"

type SiteTopDotProps = {
  index: number,
  instanceRef: any,
  currentSlide: number,
  styles: any,
  theme_color: string,
  main_visual_design_pattern: number,
}

const SliderDot = (props: SiteTopDotProps) => {
  const {
    index,
    instanceRef,
    currentSlide,
    styles,
    theme_color,
    main_visual_design_pattern,
  } = props

  return (
    <>
      <button
        onClick={() => {
          instanceRef.current?.moveToIdx(index)
        }}
        className={styles[theme_color] + " " + styles.sliderBar + (currentSlide === index ? " " + styles.active : "")}
      />
    </>
  )
}

export default SliderDot
